import CURRENCY from "@/base/enums/currency";

export default class CurrencyDTO {
  constructor() {
    this.amount = null;
    this.code = CURRENCY.TRY;
  }
}
